import React, { useState, useEffect } from "react";
import { Button } from "@material-ui/core";
import { useStateValue } from "./StateProvider";
import "./Subtotal.css";
import CurrencyFormat from "react-currency-format";
import { getBasketTotal } from "./reducer";
import { db, auth } from "./firebase";

function Subtotal() {
  const [{ basket }, dispatch] = useStateValue();
  const [ TotalCartItem , setTotalCartItem ] = useState([]);

  function GetUserUid() {
    const [uid, setUid] = useState(null);
    useEffect(() => {
      auth.onAuthStateChanged((user) => {
        if (user) {
          setUid(user.uid);
        }
      });
    }, []);
    return uid;
  }
  function GetCurrentUser() {
    const [user, setUser] = useState(null);
    const [roomDetails, setRoomDetails] = useState([]);

    useEffect(() => {
      auth.onAuthStateChanged((user) => {
        if (user) {
          db.collection("customers")
            .doc(user.uid)
            .get()
           
        } else {
          setUser(null);
        }
      });
    }, []);
    return user;
  }
  const user = GetCurrentUser();
  const uid = GetUserUid();
  useEffect(() => {
    if (uid) {
      db.collection("customers")
        .doc(uid)
        .collection("wishList")
        .get()
        .then((querySnapshot) => {
          const TotalCartItem = querySnapshot.size;
          setTotalCartItem(TotalCartItem);
        });
    }
  }, [uid]);
  return (
    <div className="subtotal">
      <CurrencyFormat
        renderText={(value) => (
          <>
            <h5>Price Details</h5>
            <strong>
              Subtotal ({TotalCartItem} items): <strong>{value}</strong>
            </strong>
           
            <small className="subtotal_gift">
              <input type="checkbox" /> This order contains a gift
            </small>
          </>
        )}
        decimalScale={2}
        value={getBasketTotal(basket)} 
        displayType={"text"}
        thousandSeparator={true}
        prefix={"₹"}
      />
      <Button>Proceed</Button>
    </div>
  );
}

export default Subtotal;
